/**
 * Calculates z-index values for all widget layers with independent button and widget z-indexes.
 * This ensures proper stacking order regardless of the base z-index values.
 *
 * Stacking order:
 * - Button, Nudge Box, and Nudge Controls are relative to bubbleZIndex
 * - Chat Window is relative to widgetZIndex
 *
 * Internal relative z-indexes within components maintain their hierarchy.
 */
export function getWidgetZIndexLayers(widgetZIndex: number, bubbleZIndex: number) {
  return {
    // main widget layers
    button: bubbleZIndex,
    nudge: bubbleZIndex + 1,
    nudgeControls: bubbleZIndex + 2,
    chatWindow: widgetZIndex,

    fabButton: {
      overlay: 0,
      text: 1,
      alertBadge: 20,
    },

    nudgeBox: {
      closeButton: 10,
      closeBorder: 1,
      inputOverlay: 1,
      quickButtonBg: -1,
    },
  };
}

export type WidgetZIndexLayers = ReturnType<typeof getWidgetZIndexLayers>;
